import React, {ChangeEventHandler, useEffect, useRef} from "react";

interface AutoResizeTextareaPops {
    value: string,
    onChange?: ChangeEventHandler<HTMLTextAreaElement>;
    onBlur?: () => void;
    onFocus?: () => void;
    onDoneEditing?: () => void;
    className?: string;
    readonly?: boolean;
}

export const AutoResizeTextarea = ({value, className, onChange, onBlur, onDoneEditing, onFocus, readonly}: AutoResizeTextareaPops): JSX.Element => {
    const textarea = useRef<HTMLTextAreaElement>(null);
    const initialValue = useRef<string>(value);

    useEffect(() => {
        const target = textarea.current;
        if (!target || target.style.height === (target.scrollHeight + "px")) return;

        target.style.height = target.scrollHeight + "px";
    }, [textarea.current, value]);

    const _onBlur = () => {
        if (onBlur) onBlur();
        if (initialValue.current !== value && onDoneEditing) {
            initialValue.current = value;
            onDoneEditing();
        }
    };

    return (<textarea ref={textarea} className={className} onChange={onChange} onBlur={_onBlur} onFocus={onFocus} value={value} readOnly={readonly}/>);
};
